<mat-card>
  <div class="fx-row align-items-center stepper">
    @for (step of steps(); track step.key; let i = $index; let last = $last) {
      <!-- each step reads as a tab: numbered, with where it stands; the line between them shows the progress -->
      <button class="fx-column align-items-center step-node"
           [class.clickable]="step.selectable && i !== activeIndex()"
           [class.disabled]="!step.selectable"
           [class.selected]="i === activeIndex()"
           [attr.aria-current]="i === activeIndex() ? 'step' : null"
           [matTooltip]="tooltipFor(step)"
           [matTooltipClass]="'uzai-tooltip'"
           (click)="select(step)">
        <div class="step-circle"
             [class.done]="isStepDone(step)"
             [class.active]="i === activeIndex()">
          @if (isStepDone(step)) {
            <mat-icon>check</mat-icon>
          } @else {
            <mat-icon fontSet="material-icons-outlined">{{ iconFor(step) }}</mat-icon>
          }
        </div>
        <span class="text bold mt-6" [class.light]="!isStepDone(step) && i !== activeIndex()"
              [class.main]="isStepDone(step) || i === activeIndex()">
          {{ i + 1 }} · {{ step.labelKey | translate }}
        </span>
        <span class="small step-state" [class.main]="isStepActive(step)">{{ stateKey(step) | translate }}</span>
      </button>

      @if (!last) {
        <div class="step-connector" [class.active]="isStepActive(step)"
             [class.done]="isStepDone(step)"></div>
      }
    }
  </div>

  @if (nextStep(); as next) {
    <div class="fx-row align-items-center justify-content-between gap-10 next-step">
      <span class="small">
        @if (runningStep(); as running) {
          {{ 'INTEGRATIONS.STEPS.RUNNING' | translate: { step: (running.labelKey | translate) } }}
        } @else {
          <span class="bold">{{ 'INTEGRATIONS.STEPS.NEXT' | translate }}</span> {{ nextActionKey(next) | translate }}
        }
      </span>
      @if (!runningStep() && steps().indexOf(next) !== activeIndex()) {
        <button class="button" (click)="select(next)">{{ 'INTEGRATIONS.STEPS.GO_TO' | translate: { step: (next.labelKey | translate) } }}</button>
      }
    </div>
  }
</mat-card>
